import { resolveModuleName } from "typescript";
import { getJWT, getUserId } from "./TokenService";
import { API_PATH } from "./servicepath";
const axios = require("axios");

const path = `${API_PATH}/api/blogs`;

export const getAllBlogs = () => {
  return axios({
    method: "get",
    url: path,
  });
};

export const getBlogById = (id) => {
  return axios({
    method: "get",
    url: `${path}/${id}`,
  });
};

export const getBlogBySlug = (slug) => {
  return axios({
    method: "get",
    url: `${path}/slug/${slug}`,
  });
};

export const createBlogService = (blogData) => {
  const headers = {
    Authorization: `Bearer ${getJWT()}`,
    "Content-Type": "multipart/form-data",
  };
  const formData = new FormData();
  for (const key in blogData) {
    formData.append(key, blogData[key]);
  }
  return axios({
    method: "post",
    url: path,
    headers,
    data: formData,
  });
};

export const editBlog = (id, blogData) => {
  const headers = {
    Authorization: `Bearer ${getJWT()}`,
  };
  return axios({
    method: "put",
    url: `${path}/${id}`,
    headers,
    data: blogData,
  });
};


export const toggleArchiveBlog = (id) => {
  const headers = {
    Authorization: `Bearer ${getJWT()}`,
  };
  return axios({
    method: "put",
    url: `${path}/${id}/archive`,
    headers,
  });
};


export const deleteBlog = (id) => {
  const headers = {
    Authorization: `Bearer ${getJWT()}`,
  };
  return axios({
    method: "delete",
    url: `${path}/${id}`,
    headers,
  });
};
